<script setup lang="ts">
import { useI18n } from '../i18n/t'

const { t } = useI18n()
</script>

<template>
  <div class="maint" role="alertdialog" aria-modal="true">
    <h1>{{ t('maintenance.title') }}</h1>
    <p>{{ t('maintenance.body') }}</p>
  </div>
</template>

<style scoped>
.maint {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: grid;
  place-content: center;
  gap: 12px;
  padding: 24px;
  text-align: center;
  background: var(--md-sys-color-surface);
  color: var(--md-sys-color-on-surface);
}
h1 {
  margin: 0;
  font-size: 1.6rem;
}
p {
  margin: 0;
  max-width: 36rem;
  color: var(--md-sys-color-on-surface-variant);
}
</style>
